var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTacho = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "13px",
    viewBox: "0 0 20 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E18F87A9-C5EF-4E53-A5B2-86E386C48292") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5110577,16.8169439 L7.74742331,13.6585046 L9.25257669,12.3414954 L12.0163445,15.5000872 C12.8372424,15.5088512 13.5,16.1770279 13.5,17 C13.5,17.2178428 13.5,17.5511762 13.5,18 L10.5,18 C10.5,17.8856181 10.5,17.5522847 10.5,17 C10.5,16.9380318 10.5037577,16.8769413 10.5110577,16.8169439 Z M6.6010238,9.40049869 L7.78086881,10.875305 L6.21913119,12.124695 L5.27081702,10.9393023 C4.46252454,12.1944356 4.00622414,13.7430204 4.00622414,15.5 L4.00622414,16 L6,16 L6,18 L2.00622414,18 L2.00622414,15.5 C2.00622414,9.61089807 6.27746425,5.5 12,5.5 C17.7237001,5.5 22,9.61182679 22,15.5 L22,18 L18,18 L18,16 L20,16 L20,15.5 C20,13.741848 19.5421938,12.1921152 18.7315772,10.9363095 L17.7808688,12.124695 L16.2191312,10.875305 L17.4001427,9.3990406 C16.2296388,8.38138963 14.7221953,7.73242398 13,7.55165257 L13,9 L11,9 L11,7.55167327 C9.27764977,7.73254683 7.77067789,8.38196651 6.6010238,9.40049869 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Sixtbook_dashboard",
    transform: "translate(-22.000000, -613.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_tacho",
    transform: "translate(20.000000, 608.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#ffffff",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTacho);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_tacho.b4fc4b6313599949a8d627f23427fece.svg";